import React from 'react';
import UnderConstructionScreen from './UnderConstructionScreen';

const HostingResourcesScreen = () => (
    <UnderConstructionScreen
        eyebrow="Hosting Resources"
        icon="book-open-page-variant-outline"
        title="Everything you need to run a great camp."
        subtitle="We are curating a library of guides, templates, and best practices for SnapCamp hosts — from setting up your first session to growing a thriving program."
        accentColor="#059669"
        features={[
            {
                icon: 'file-document-outline',
                title: 'Host guides and playbooks',
                description: 'Step-by-step documentation covering enrollment setup, scheduling, pricing, and communication with families.',
            },
            {
                icon: 'chart-bar',
                title: 'Analytics and insights',
                description: 'Understand your camp performance, track registrations, and see what families are looking for in your area.',
            },
            {
                icon: 'lightbulb-on-outline',
                title: 'Growth tips and best practices',
                description: 'Learn from top-performing hosts on how to attract more families, improve reviews, and build a stronger program.',
            },
        ]}
        contactPrompt="Need hosting help now?"
        contactEmail="hosting@snapcamp.ai"
    />
);

export default HostingResourcesScreen;
